import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import PriceArea from './PriceArea';
import Newsletter from '../../components/Newsletter';
import Testimonial from './TestimonialArea';

const PriceMain = () => {
  return (
    <main>
      <Breadcrumb title="Pricing" />
      <PriceArea />
      <Newsletter />
      <Testimonial />
    </main>
  );
};

export default PriceMain;
